/**
 * Translations for the "Tamam al-Salah" feature.
 * Covers all 13 languages currently supported by Falak.
 */

export const TAMAM_STRINGS = {
  // Entry button on Prayer Times card
  entryTitle: {
    ar: 'تمام الصلاة',
    en: 'Complete your Prayer',
    id: 'Sempurnakan Salatmu',
    ur: 'نماز مکمل کریں',
    fr: 'Accomplir la Prière',
    bn: 'নামায পূর্ণ করুন',
    zh: '完成礼拜',
    fa: 'تمام نماز',
    tr: 'Namazı Tamamla',
    es: 'Completa tu Oración',
    pt: 'Complete sua Oração',
    de: 'Vollende dein Gebet',
    it: 'Completa la tua Preghiera',
  },
  entrySubtitle: {
    ar: 'صلّ باطمئنان',
    en: 'Pray with tranquility',
    id: 'Salat dengan tenang',
    ur: 'اطمینان سے نماز پڑھیں',
    fr: 'Priez en toute sérénité',
    bn: 'শান্তিতে নামায পড়ুন',
    zh: '安心礼拜',
    fa: 'با آرامش نماز بخوان',
    tr: 'Huzurla namaz kıl',
    es: 'Reza con tranquilidad',
    pt: 'Ore com tranquilidade',
    de: 'Bete in Ruhe',
    it: 'Prega con serenità',
  },

  // Welcome modal
  welcomeIntro: {
    ar: 'أربع دوائر لأربع ركعات — الأولى تُضيء عند البدء، ثم لمسة بعد كلّ ركعة',
    en: 'Four dots for four rakats — the first lights up at start, then tap after each rakat',
    id: 'Empat titik untuk empat rakaat — yang pertama menyala saat mulai, lalu sentuh setelah setiap rakaat',
    ur: 'چار رکعتوں کے لیے چار نقطے — پہلا شروع میں روشن ہو گا، پھر ہر رکعت کے بعد ٹچ کریں',
    fr: 'Quatre points pour quatre rakats — le premier s\'allume au début, puis touchez après chaque rakat',
    bn: 'চার রাকাতের জন্য চার বিন্দু — প্রথমটি শুরুতে জ্বলে ওঠে, তারপর প্রতিটি রাকাতের পর স্পর্শ করুন',
    zh: '四个圆点代表四拜——第一个在开始时亮起，之后每完成一拜后触摸屏幕',
    fa: 'چهار نقطه برای چهار رکعت — اولی در آغاز روشن می‌شود، سپس پس از هر رکعت لمس کنید',
    tr: 'Dört rekat için dört nokta — birincisi başlangıçta yanar, ardından her rekattan sonra dokunun',
    es: 'Cuatro puntos para cuatro rakats — el primero se enciende al inicio, luego toca tras cada rakat',
    pt: 'Quatro pontos para quatro rakats — o primeiro acende ao começar, depois toque após cada rakat',
    de: 'Vier Punkte für vier Rakats — der erste leuchtet beim Start auf, dann nach jedem Rakat antippen',
    it: 'Quattro punti per quattro rakat — il primo si accende all\'inizio, poi tocca dopo ogni rakat',
  },
  step1: {
    ar: 'ضع الهاتف يمين أو يسار موضع سجودك',
    en: 'Place your phone beside your prostration spot',
    id: 'Letakkan ponsel di samping tempat sujud Anda',
    ur: 'اپنے فون کو سجدے کی جگہ کے پاس رکھیں',
    fr: 'Placez votre téléphone à côté de votre lieu de prosternation',
    bn: 'আপনার সিজদার স্থানের পাশে ফোনটি রাখুন',
    zh: '将手机放在您叩头处旁边',
    fa: 'گوشی را کنار محل سجده خود قرار دهید',
    tr: 'Telefonunuzu secde yerinizin yanına koyun',
    es: 'Coloca tu teléfono junto a tu lugar de postración',
    pt: 'Coloque seu telefone ao lado do local de prostração',
    de: 'Legen Sie Ihr Telefon neben Ihren Prostrationsplatz',
    it: 'Metti il telefono accanto al luogo della prostrazione',
  },
  step2: {
    ar: 'الْمَس الشاشة بعد السجود الأخير من كل ركعة',
    en: 'Tap the screen after the final prostration of each rakat',
    id: 'Sentuh layar setelah sujud terakhir dari setiap rakaat',
    ur: 'ہر رکعت کے آخری سجدے کے بعد اسکرین کو چھوئیں',
    fr: 'Touchez l\'écran après la dernière prosternation de chaque rakat',
    bn: 'প্রতিটি রাকাতের শেষ সিজদার পর স্ক্রীন স্পর্শ করুন',
    zh: '每一拜最后叩头后触摸屏幕',
    fa: 'پس از سجده آخر هر رکعت، صفحه را لمس کنید',
    tr: 'Her rekatın son secdesinden sonra ekrana dokunun',
    es: 'Toca la pantalla tras la última postración de cada rakat',
    pt: 'Toque na tela após a última prostração de cada rakat',
    de: 'Tippen Sie den Bildschirm nach der letzten Prostration jedes Rakats an',
    it: 'Tocca lo schermo dopo l\'ultima prostrazione di ogni rakat',
  },
  step3: {
    ar: 'للخروج: اضغط على ✕ في الأعلى',
    en: 'To exit: tap ✕ at the top corner',
    id: 'Untuk keluar: ketuk ✕ di sudut atas',
    ur: 'باہر نکلنے کے لیے: اوپری کونے میں ✕ کو دبائیں',
    fr: 'Pour quitter : appuyez sur ✕ en haut',
    bn: 'বের হতে: উপরের কোণে ✕ চাপুন',
    zh: '退出：点击顶部的 ✕',
    fa: 'برای خروج: روی ✕ در بالا ضربه بزنید',
    tr: 'Çıkmak için: üst köşedeki ✕ simgesine dokunun',
    es: 'Para salir: toca ✕ en la esquina superior',
    pt: 'Para sair: toque em ✕ no canto superior',
    de: 'Zum Beenden: oben auf ✕ tippen',
    it: 'Per uscire: tocca ✕ in alto',
  },
  closeSession: {
    ar: 'إنهاء الصلاة',
    en: 'End prayer',
    id: 'Akhiri salat',
    ur: 'نماز ختم کریں',
    fr: 'Terminer la prière',
    bn: 'নামায শেষ করুন',
    zh: '结束礼拜',
    fa: 'پایان نماز',
    tr: 'Namazı bitir',
    es: 'Terminar oración',
    pt: 'Terminar oração',
    de: 'Gebet beenden',
    it: 'Termina preghiera',
  },
  brightness: {
    ar: 'شدّة الإضاءة',
    en: 'Brightness',
    id: 'Kecerahan',
    ur: 'روشنی',
    fr: 'Luminosité',
    bn: 'উজ্জ্বলতা',
    zh: '亮度',
    fa: 'روشنایی',
    tr: 'Parlaklık',
    es: 'Brillo',
    pt: 'Brilho',
    de: 'Helligkeit',
    it: 'Luminosità',
  },
  brightnessAuto: {
    ar: 'تلقائي',
    en: 'Auto',
    id: 'Otomatis',
    ur: 'خودکار',
    fr: 'Auto',
    bn: 'স্বয়ংক্রিয়',
    zh: '自动',
    fa: 'خودکار',
    tr: 'Otomatik',
    es: 'Automático',
    pt: 'Automático',
    de: 'Automatisch',
    it: 'Automatico',
  },
  brightnessDim: {
    ar: 'خافتة',
    en: 'Dim',
    id: 'Redup',
    ur: 'مدھم',
    fr: 'Faible',
    bn: 'কম',
    zh: '暗',
    fa: 'کم',
    tr: 'Kısık',
    es: 'Tenue',
    pt: 'Tênue',
    de: 'Gedimmt',
    it: 'Attenuata',
  },
  brightnessMed: {
    ar: 'متوسطة',
    en: 'Medium',
    id: 'Sedang',
    ur: 'درمیانی',
    fr: 'Moyenne',
    bn: 'মাঝারি',
    zh: '中等',
    fa: 'متوسط',
    tr: 'Orta',
    es: 'Media',
    pt: 'Média',
    de: 'Mittel',
    it: 'Media',
  },
  brightnessBright: {
    ar: 'مضيئة',
    en: 'Bright',
    id: 'Terang',
    ur: 'روشن',
    fr: 'Vive',
    bn: 'উজ্জ্বল',
    zh: '明亮',
    fa: 'روشن',
    tr: 'Parlak',
    es: 'Brillante',
    pt: 'Brilhante',
    de: 'Hell',
    it: 'Brillante',
  },
  dndHint: {
    ar: 'يُنصح بتفعيل "عدم الإزعاج" قبل البدء',
    en: 'It is recommended to enable "Do Not Disturb" before starting',
    id: 'Disarankan mengaktifkan "Jangan Ganggu" sebelum mulai',
    ur: 'شروع کرنے سے پہلے "ڈسٹرب نہ کریں" کو فعال کرنے کی سفارش کی جاتی ہے',
    fr: 'Il est recommandé d\'activer le mode "Ne pas déranger" avant de commencer',
    bn: 'শুরু করার আগে "বিরক্ত করবেন না" সক্রিয় করার সুপারিশ করা হয়',
    zh: '开始前建议启用"勿扰模式"',
    fa: 'توصیه می‌شود قبل از شروع "مزاحم نشوید" را فعال کنید',
    tr: 'Başlamadan önce "Rahatsız Etme" modunu etkinleştirmeniz önerilir',
    es: 'Se recomienda activar "No molestar" antes de comenzar',
    pt: 'Recomenda-se ativar "Não perturbe" antes de começar',
    de: 'Es wird empfohlen, vor dem Start „Nicht stören" zu aktivieren',
    it: 'Si consiglia di attivare "Non disturbare" prima di iniziare',
  },
  dontShowAgain: {
    ar: 'لا تعرض هذه الشاشة مرة أخرى',
    en: "Don't show this screen again",
    id: 'Jangan tampilkan layar ini lagi',
    ur: 'یہ اسکرین دوبارہ نہ دکھائیں',
    fr: 'Ne plus afficher cet écran',
    bn: 'এই স্ক্রীনটি আর দেখাবেন না',
    zh: '不再显示此屏幕',
    fa: 'این صفحه را دیگر نشان نده',
    tr: 'Bu ekranı bir daha gösterme',
    es: 'No mostrar esta pantalla de nuevo',
    pt: 'Não mostrar esta tela novamente',
    de: 'Diese Anzeige nicht mehr zeigen',
    it: 'Non mostrare più questa schermata',
  },
  startPrayer: {
    ar: 'ابدأ الصلاة',
    en: 'Start Prayer',
    id: 'Mulai Salat',
    ur: 'نماز شروع کریں',
    fr: 'Commencer la prière',
    bn: 'নামায শুরু করুন',
    zh: '开始礼拜',
    fa: 'شروع نماز',
    tr: 'Namaza başla',
    es: 'Comenzar oración',
    pt: 'Começar oração',
    de: 'Gebet beginnen',
    it: 'Inizia preghiera',
  },
  swipeToExit: {
    ar: 'اسحب لأعلى للخروج',
    en: 'Swipe up to exit',
    id: 'Geser ke atas untuk keluar',
    ur: 'باہر نکلنے کے لیے اوپر سوائپ کریں',
    fr: 'Glissez vers le haut pour quitter',
    bn: 'বের হতে উপরে সোয়াইপ করুন',
    zh: '向上滑动退出',
    fa: 'برای خروج به بالا بکشید',
    tr: 'Çıkmak için yukarı kaydırın',
    es: 'Desliza hacia arriba para salir',
    pt: 'Deslize para cima para sair',
    de: 'Nach oben wischen zum Beenden',
    it: 'Scorri verso l\'alto per uscire',
  },
  releaseToExit: {
    ar: 'أفلت للخروج',
    en: 'Release to exit',
    id: 'Lepaskan untuk keluar',
    ur: 'باہر نکلنے کے لیے چھوڑیں',
    fr: 'Relâchez pour quitter',
    bn: 'বের হতে ছেড়ে দিন',
    zh: '松开退出',
    fa: 'برای خروج رها کنید',
    tr: 'Çıkmak için bırakın',
    es: 'Suelta para salir',
    pt: 'Solte para sair',
    de: 'Loslassen zum Beenden',
    it: 'Rilascia per uscire',
  },
  // "New" ribbon shown on the entry button for 30 days after launch
  newRibbon: {
    ar: 'جديد',
    en: 'NEW',
    id: 'BARU',
    ur: 'نیا',
    fr: 'NOUVEAU',
    bn: 'নতুন',
    zh: '新',
    fa: 'جدید',
    tr: 'YENİ',
    es: 'NUEVO',
    pt: 'NOVO',
    de: 'NEU',
    it: 'NUOVO',
  },
  // Exit summary: "You performed N rakats"
  performedOne: {
    ar: 'أدّيت ركعة واحدة',
    en: 'You performed 1 rakat',
    id: 'Anda menunaikan 1 rakaat',
    ur: 'آپ نے 1 رکعت ادا کی',
    fr: 'Vous avez accompli 1 rakat',
    bn: 'আপনি 1 রাকাত আদায় করেছেন',
    zh: '您完成了 1 拜',
    fa: 'شما 1 رکعت ادا کردید',
    tr: '1 rekat kıldınız',
    es: 'Realizaste 1 rakat',
    pt: 'Você realizou 1 rakat',
    de: 'Sie haben 1 Rakat vollzogen',
    it: 'Hai compiuto 1 rakat',
  },
  performedTwo: {
    ar: 'أدّيت ركعتين',
    en: 'You performed 2 rakats',
    id: 'Anda menunaikan 2 rakaat',
    ur: 'آپ نے 2 رکعتیں ادا کیں',
    fr: 'Vous avez accompli 2 rakats',
    bn: 'আপনি 2 রাকাত আদায় করেছেন',
    zh: '您完成了 2 拜',
    fa: 'شما 2 رکعت ادا کردید',
    tr: '2 rekat kıldınız',
    es: 'Realizaste 2 rakats',
    pt: 'Você realizou 2 rakats',
    de: 'Sie haben 2 Rakats vollzogen',
    it: 'Hai compiuto 2 rakat',
  },
  performedMany: {
    // {n} placeholder
    ar: 'أدّيت {n} ركعات',
    en: 'You performed {n} rakats',
    id: 'Anda menunaikan {n} rakaat',
    ur: 'آپ نے {n} رکعتیں ادا کیں',
    fr: 'Vous avez accompli {n} rakats',
    bn: 'আপনি {n} রাকাত আদায় করেছেন',
    zh: '您完成了 {n} 拜',
    fa: 'شما {n} رکعت ادا کردید',
    tr: '{n} rekat kıldınız',
    es: 'Realizaste {n} rakats',
    pt: 'Você realizou {n} rakats',
    de: 'Sie haben {n} Rakats vollzogen',
    it: 'Hai compiuto {n} rakat',
  },
};

/**
 * Return the correct summary string for the number of rakats performed.
 * Arabic has distinct forms for 1, 2, and >2 which we honour via the
 * dedicated *One / *Two / *Many keys. Other languages naturally handle
 * plural via the *Many placeholder.
 */
export const performedRakatsMessage = (n, lang, tt) => {
  if (n <= 0) return '';
  if (n === 1) return tt(TAMAM_STRINGS.performedOne, lang);
  if (n === 2) return tt(TAMAM_STRINGS.performedTwo, lang);
  return tt(TAMAM_STRINGS.performedMany, lang).replace('{n}', String(n));
};
